import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-toolbox';
import S from '../styles.scss';

const EditToggleButton = ({ isEditable, onClick, className, actionLabel }) =>
  <Button
    label={isEditable ? 'Done' : actionLabel}
    className={`${S.editToggleButton} ${className}`}
    onClick={onClick}
    inverse
  />;

EditToggleButton.propTypes = {
  isEditable: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  actionLabel: PropTypes.string,
};

EditToggleButton.defaultProps = {
  isEditable: false,
  className: '',
  actionLabel: 'Edit',
};

export default EditToggleButton;



// WEBPACK FOOTER //
// ./client/app/shared/components/EditableTable/components/editToggleButton.jsx